import { AirTrackingAccess } from "components/DynamicForms/AirTracking/AirTrackingAccess";
import { AirTrackingApi } from "components/DynamicForms/AirTracking/AirTrackingApi";
import { AirTrackingIntegration } from "components/DynamicForms/AirTracking/AirTrackingIntegration";
import { CarbonEmissionsAccess } from "components/DynamicForms/CarbonEmissions/CarbonEmissionsAccess";
import { CarbonEmissionsApi } from "components/DynamicForms/CarbonEmissions/CarbonEmissionsApi";
import { CarbonEmissionsIntegration } from "components/DynamicForms/CarbonEmissions/CarbonEmissionsIntegration";
import { CargoLoadOptimizerAccess } from "components/DynamicForms/CargoLoadOptimizer/CargoLoadOptimizerAccess";
import { CargoLoadOptimizerApi } from "components/DynamicForms/CargoLoadOptimizer/CargoLoadOptimizerApi";
import { CargoLoadOptimizerIntegration } from "components/DynamicForms/CargoLoadOptimizer/CargoLoadOptimizerIntegration";
import { ContainerTrackingAccess } from "components/DynamicForms/ContainerTracking/ContainerTrackingAccess";
import { ContainerTrackingApi } from "components/DynamicForms/ContainerTracking/ContainerTrackingApi";
import { ContainerTrackingIntegration } from "components/DynamicForms/ContainerTracking/ContainerTrackingIntegration";
import { TransitTimeAccess } from "components/DynamicForms/TransitTime/TransitTimeAccess";
import { TransitTimeApi } from "components/DynamicForms/TransitTime/TransitTimeApi";
import { TransitTimeIntegration } from "components/DynamicForms/TransitTime/TransitTimeIntegration";
import { VesselSchedulesAccess } from "components/DynamicForms/VesselSchedules/VesselSchedulesAccess";
import { VesselSchedulesApi } from "components/DynamicForms/VesselSchedules/VesselSchedulesApi";
import { VesselSchedulesIntegration } from "components/DynamicForms/VesselSchedules/VesselSchedulesIntegration";
import { REQUEST_TYPE_VALUES, TOOL_VALUES } from "constants/selects.content";

const { api, app, web } = REQUEST_TYPE_VALUES;

export const FIELDS_GROUP = {
  [TOOL_VALUES["container-tracking"]]: {
    [web]: <ContainerTrackingAccess />,
    [api]: <ContainerTrackingApi />,
    [app]: <ContainerTrackingIntegration />,
  },
  [TOOL_VALUES["air-tracking"]]: {
    [web]: <AirTrackingAccess />,
    [api]: <AirTrackingApi />,
    [app]: <AirTrackingIntegration />,
  },
  [TOOL_VALUES["vessel-schedules"]]: {
    [web]: <VesselSchedulesAccess />,
    [api]: <VesselSchedulesApi />,
    [app]: <VesselSchedulesIntegration />,
  },
  [TOOL_VALUES["transit-time"]]: {
    [web]: <TransitTimeAccess />,
    [api]: <TransitTimeApi />,
    [app]: <TransitTimeIntegration />,
  },
  [TOOL_VALUES["co2"]]: {
    [web]: <CarbonEmissionsAccess />,
    [api]: <CarbonEmissionsApi />,
    [app]: <CarbonEmissionsIntegration />,
  },
  [TOOL_VALUES["cargo-load-optimizer"]]: {
    [web]: <CargoLoadOptimizerAccess />,
    [api]: <CargoLoadOptimizerApi />,
    [app]: <CargoLoadOptimizerIntegration />,
  },
} as const;
